import {createTileMediaError, TileMediaError} from './errors';
import IN_MEMORY_CACHE from './inMemoryCache';

export async function fetchFileBlob(directURL: string): Promise<Blob | null> {
  return await fetchBlobDeduped(directURL);
}

async function fetchBlobDeduped(url: string): Promise<Blob> {
  const existingPromise = IN_MEMORY_CACHE.BLOB_PROMISE_BY_URL.get(url);
  if (existingPromise) {
    return existingPromise;
  }

  // eslint-disable-next-line wandb/no-unprefixed-urls
  const blobPromise = fetch(url)
    .then(async resp => {
      if (!resp.ok) {
        throw createTileMediaError(
          `HTTP ${resp.status}: ${resp.statusText}`,
          'REQUEST_FAILED'
        );
      }
      return resp.blob();
    })
    .catch(err => {
      console.error(`Error fetching file blob: ${err}`);
      if (err instanceof TileMediaError) {
        throw err;
      }
      throw createTileMediaError(
        'Failed to fetch media',
        'UNKNOWN',
        err instanceof Error ? err : undefined
      );
    });

  IN_MEMORY_CACHE.BLOB_PROMISE_BY_URL.set(url, blobPromise);
  return blobPromise;
}

export function getObjectURLForBlob(b: Blob): string {
  const objectURL =
    IN_MEMORY_CACHE.OBJECT_URL_BY_BLOB.get(b) ?? URL.createObjectURL(b);
  IN_MEMORY_CACHE.OBJECT_URL_BY_BLOB.set(b, objectURL);
  return objectURL;
}
